import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationRussian from '@/common/locales/ru/translation.json';
import translationUzbekLatin from '@/common/locales/uz/translation.json';
import translationKarakalpak from '@/common/locales/uz_cyr/translation.json';

const resources = {
  uz: {
    translation: translationUzbekLatin,
  },
  ru: {
    translation: translationRussian,
  },
  uz_cyr: {
    translation: translationKarakalpak,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: 'uz', //default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
